import React from 'react'
import Modal from "components/Modal";
import Button from "components/Buttons";

function ModalComponent({ title, children, setOpenModal, modalIsOpen, onConfirm, loading, icon }) {

    const handleClose = () => {
        setOpenModal(false)
    }

    return (
        <Modal
            isCloseIcon
            title={title}
            modalIsOpen={modalIsOpen}
            closeModal={handleClose}
            shouldCloseOnOverlayClick={true}
            className="w-[90%] sm:w-[462px] !rounded-[24px] !p-10 !pt-12"
            titleClassName="!text-[32px] !font-barlowCondensed font-bold uppercase tracking-tight text-center"
        >
            <div className="flex flex-col items-center">
                {icon && (
                    <img
                        src={icon}
                        alt="icon"
                        className='flex justify-center items-center mx-auto mb-6 h-12 w-auto'
                    />
                )}

                <div className="w-full text-center">
                    {children}
                </div>

                <div className='flex justify-center items-center gap-x-4 mt-10 w-full'>
                    <Button
                        loading={loading}
                        onClick={onConfirm}
                        className='confirm_btn cursor-pointer !h-[56px] flex-1 !rounded-[56px] !w-auto font-montserrat font-bold'
                    >
                        Confirm
                    </Button>
                    <Button
                        disabled={loading}
                        onClick={handleClose}
                        className='cancel_btns cursor-pointer !h-[56px] flex-1 !rounded-[56px] !w-auto font-montserrat font-bold'
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalComponent
